<template>
         <el-dialog :visible.sync="storeDetailDialog" width="50%" top="5vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card>
            <div style="height: 700px; overflow: auto">
                <el-tabs v-model="card" type="card" @tab-click="chooseTabs" style="height:700px">
                <el-tab-pane label="基本信息" name="1">
                    <el-form label-width="85px" label-position="left">
                        <el-row :gutter="20">
                            <el-divider content-position="left">代理信息</el-divider>
                        </el-row>  
                        <el-row :gutter="20">
                            <el-col :span="10"><el-form-item label="代理名称"><span>{{response.storeInfo.csName}}</span></el-form-item></el-col>
                            <el-col :span="10"><el-form-item label="代理电话"><span >{{response.storeInfo.csPhone}}</span></el-form-item></el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-divider content-position="left">商户信息</el-divider>
                        </el-row>  
                        <el-row :gutter="20">
                            <el-col :span="10"><el-form-item label="商户名称"><span>{{response.storeInfo.bsName}}</span></el-form-item></el-col>
                            <el-col :span="10"><el-form-item label="商户电话"><span >{{response.storeInfo.bsPhone}}</span></el-form-item></el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-divider content-position="left">BD信息</el-divider>
                        </el-row>  
                        <el-row :gutter="20">
                            <el-col :span="10"><el-form-item label="BD名称"><span>{{response.storeInfo.bdName}}</span></el-form-item></el-col>
                            <el-col :span="10"><el-form-item label="BD电话"><span >{{response.storeInfo.bdPhone}}</span></el-form-item></el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-divider content-position="left">门店信息</el-divider>
                        </el-row>  
                        <el-row :gutter="20">
                            <el-col :span="10"><el-form-item label="门店编号"><span>{{response.storeInfo.storeCode}}</span></el-form-item></el-col>
                            <el-col :span="10"><el-form-item label="门店名称"><span >{{response.storeInfo.storeName}}</span></el-form-item></el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="10"><el-form-item label="门店单价"><span>{{response.storeInfo.unitPrice}}</span></el-form-item></el-col>
                            <el-col :span="10"><el-form-item label="封顶价格"><span >{{response.storeInfo.maxPrice}}</span></el-form-item></el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="10"><el-form-item label="营业时间"><span>{{response.storeInfo.openTime}}</span></el-form-item></el-col>
                            <el-col :span="10"><el-form-item label="创建时间"><span >{{response.storeInfo.createTime}}</span></el-form-item></el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="10"><el-form-item label="是否连锁">{{response.storeInfo.chainFlag}}</el-form-item></el-col>
                            <el-col :span="10"><el-form-item label="人均消费">{{response.storeInfo.expense}}</el-form-item></el-col>
                        </el-row>
                         <el-row :gutter="20">
                            <el-col :span="10"><el-form-item label="联系人"><span>{{response.storeInfo.contactPerson}}</span></el-form-item></el-col>
                            <el-col :span="10"><el-form-item label="联系电话"><span >{{response.storeInfo.contactPhone}}</span></el-form-item></el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="10"><el-form-item label="所在地区">{{response.storeInfo.area}}</el-form-item></el-col>
                            <el-col :span="10"><el-form-item label="门店品类">{{response.storeInfo.category}}</el-form-item></el-col>
                        </el-row>
                       
                        <el-row :gutter="20">
                            <el-col :span="10"><el-form-item label="详细地址">{{response.storeInfo.address}}</el-form-item></el-col>
                            <el-col :span="10">
                                <el-form-item label="门店照片">
                                    <div style="height: 200px;">
                                        <img :src="url" width="100%" height="100%"/>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="设备信息" name="2">
                    <el-table :data="response.storeInfo.devices" style="width: 100%" height="630" border :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                        <el-table-column label="设备编号" align="center" prop="deviceId" width="180"></el-table-column>
                        <el-table-column label="设备类型" align="center" prop="socket"></el-table-column>
                        <el-table-column label="状态" align="center" prop="state"></el-table-column>
                        <el-table-column label="离线时间" align="center" width="180">
                            <template slot-scope="scope"><span v-if="scope.row.state === '离线'">{{scope.row.offLineTime | formatDate}}</span></template>
                        </el-table-column>
                        <el-table-column label="部署时间" align="center" width="180">
                            <template slot-scope="scope">{{scope.row.deployTime | formatDate}}</template>
                        </el-table-column>
                        <el-table-column label="部署人" align="center" prop="deployPerson"></el-table-column>
                        <el-table-column label="联系方式" align="center" width="150" prop="deployPhone"></el-table-column>
                        <el-table-column label="解绑" align="center" width="100">
                            <template slot-scope="scope">
                                <el-button type="danger" plain @click="unbinding(scope.row.deviceId)" size="small">解绑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="设备记录" name="3">
                    <el-table :data="response.storeInfo.deviceDeployHis" style="width: 100%" height="630" border :header-cell-style="{background:'#01DFD7',color:'#fff'}">
                        <el-table-column label="设备编号" align="center" prop="deviceId" width="200"></el-table-column>
                        <el-table-column label="操作类型" align="center" prop="type"></el-table-column>
                        <el-table-column label="操作时间" align="center">
                            <template slot-scope="scope">{{scope.row.time | formatDate}}</template>
                        </el-table-column>
                        <el-table-column label="操作人" align="center" prop="person"></el-table-column>
                    </el-table>
                </el-tab-pane>
                </el-tabs>
            </div>
        </el-card>
    </el-dialog>
</template>
<script>
import {getStoreDetail, deviceUnbinding} from '../../api/relation/storeDeviceRelation.js'
import {GLOBAL_URL} from '../../config/config.js'
import { formatDate } from "../../utils/date";
export default {
    data() {
        return {
            storeDetailDialog: false,
            loading: false,
            card: "1",
            response: {storeInfo: [],total: 0},
            query: {current: 1, size: 10},
            url: '',
            storeId: ''
        }
    },
    methods: {
        init(value) {
            this.storeDetailDialog = true;
            this.storeId = value;
            getStoreDetail(value).then(result=>{
                this.response.storeInfo = result.data;
                this.url = GLOBAL_URL.imageUrl+result.data.headPic
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.csDetailDialog = false;
            this.card = "1";
            this.response.storeInfo = [];
            this.url = "";
            this.value = "";
        },

        /**
         * 页码改变
         */
        currenChangeHandle(value){
            getCsStoreInfo(this.response.storeInfo.csId,{current: value, size: this.query.size}).then(result=>{
                this.response.storeInfo = result.data.records;
                this.response.total = result.data.total;
            })
        },

        /**
         * 解绑设备
         */
        unbinding(deviceId){
                this.$confirm('确认是否取消'+deviceId+'设备的绑定', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'waring',
                center: true
            }).then(() => {
                deviceUnbinding({deviceId: deviceId}).then(result=>{
                    this.$emit('unbinding-succeed','添加成功')
                    this.$confirm('操作成功', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'success',
                    center: true
                }).then(() => {
                    this.init(this.storeId);
                })
                })
            }).catch(()=>{
            })
        }
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  }
}
</script>
<style scoped>
.el-pagination{
    margin-left: 15%;
}
</style>>


// WEBPACK FOOTER //
// src/pages/relation/storeDetail.vue